export default __webpack_public_path__ + "static/cake-open-ab7fa3bb5b7108ce3c8c293752c6bbad.png";